import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkMenuIcon from '@/public/icons/link_menu.svg';
import { Link } from '@mui/material';
import { useWorkEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { GTMEventName, WorkPageAreaType } from '@/constant/gtm';

type FeedBackLinkProps = {
  pageArea: WorkPageAreaType;
};

const FeedBackLink = ({ pageArea }: FeedBackLinkProps) => {
  const workEventTracker = useWorkEventTracker(pageArea);
  const { t } = useTranslation();

  const sendGTMEvent = () => {
    // GA Work - Approval 13번 / Document 6번
    workEventTracker(GTMEventName.clickOutLink, {
      area_name: '',
      button_text: '피드백 남기기',
    });
  };
  return (
    <Link
      onClick={sendGTMEvent}
      href={
        'https://fnf.atlassian.net/servicedesk/customer/portal/50/create/825'
      }
      target={'_blank'}
      rel={'noreferrer'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '18px',
        marginBottom: '200px',
        fontSize: '16px',
        color: 'var(--dk-accent, #0066CC)',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
        'svg > path': { stroke: 'var(--dk-accent, #0066CC)' },
      }}
    >
      <LinkMenuIcon width={24} height={24} />
      {t('피드백 남기기')}
    </Link>
  );
};

export default FeedBackLink;
